import {action} from "typesafe-actions";
import {FETCH_ORGANIZATION, FETCH_USER_ORGANIZATIONS} from "./constants";

export const fetchOrganization = (organizationId: string) => action(FETCH_ORGANIZATION, { organizationId });

export const fetchUserOrganizations = () => action(FETCH_USER_ORGANIZATIONS, {});
